const DECLINE_SOURCE_LABEL_KEYS = Object.freeze({
	invitation_declined: 'application.decline-source.invitation-declined',
	withdrawn: 'application.decline-source.withdrawn'
})

export function getDeclineSourceLabelKey(source) {
	return DECLINE_SOURCE_LABEL_KEYS[source] || null
}

export function isApplicationArchiveLocked(application) {
	if (application?.status !== 'denied') return false

	return (
		application.decline_source == null ||
		application.decline_source === 'withdrawn'
	)
}
